import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { DefaultStates } from '../../../vendor_core/core/src/states/DefaultStates';
import StateMachine from '../../../vendor_core/core/src/states/StateMachine';
import { UIButtons } from "../../../vendor_core/core/src/ui/UIButtons";
import { UIUpdateEvent } from "../../../vendor_core/core/src/ui/UIUpdateEvents";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import SwitchButton from "../../../vendor_core/core/src/views/components/SwitchButton";
import UIDesktop from "../../../vendor_core/src/base/ui/UIDesktop";
import { VendorCommandsEnum } from "../../../vendor_core/src/commands/VendorCommandsEnum";
import VendorModel from "../../../vendor_core/src/model/VendorModel";
import Configs from '../../../vendor_core/src/vendorConfigs/Configs';
import DoubleChanceConfig from "../../configs/DoubleChanceConfig";
import DoubleChanceModel from "../../model/DoubleChanceModel";

export default class TRWUIView extends UIDesktop {

    public create(): void {
        super.create();

        if (this.scene.buttons.has(UIButtons.FeatureBuy)) {
           this.assignInterraction(
               Commands.TOGGLE_BUY_FEATURE,
               this.scene.buttons.get(UIButtons.FeatureBuy),
               SoundVars.BUTTON_CLICK
           );
        }
    }

    protected addSpecificFeatureElement() {
        // const btnName = "buyfeatureSpin";
        const btnName = Layout.isLandscape() ? "buyfeatureSpin" : "buyfeatureSpin_pt";
        const dcButton = this.scene.buttons.get(btnName);
        dcButton.on(PointerEvents.DOWN, () => {
            CommandManager.execute(VendorCommandsEnum.FEATURE_BUTTON_OPTIONS);
            SoundController.playSound(SoundVars.BUTTON_CLICK)
        });

        let btnValue = this.scene.sceneMoneyFields.get("dc_bet_amount");
        btnValue.value = BetModel.betMultipliers[BetModel.coinSizeIndex] *
                         DoubleChanceConfig.scatterBoostCreditsPerBet;

        ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene()
            .orientationChangeCallback = () => {
                this.scene.buttons.get("buyfeatureSpin").off(PointerEvents.DOWN);
                this.scene.buttons.get("buyfeatureSpin_pt").off(PointerEvents.DOWN);
                let isActive = !DoubleChanceModel.isActivated;
                if (GameModel.isReplay && DoubleChanceModel.mode === 1) {
                    isActive = false;
                }
                // const btnName = "buyfeatureSpin";
                const btnName = Layout.isLandscape() ? "buyfeatureSpin" : "buyfeatureSpin_pt";
                (this.scene.buttons.get(btnName) as SwitchButton).switch(!isActive);

                this.scene.buttons.get(btnName).on(PointerEvents.DOWN, () => {
                    CommandManager.execute(VendorCommandsEnum.FEATURE_BUTTON_OPTIONS);
                    SoundController.playSound(SoundVars.BUTTON_CLICK)
                });
            };

        if (GameModel.isReplay && DoubleChanceModel.mode === 1) {
            (dcButton as SwitchButton).switch(true);
        }
    }

    public update(event: UIUpdateEvent, props?: any): void {
        if (this.scene) {
            super.update(event, props);
            this.buyFeatureButtonsBehavior();
        }

    }

    private buyFeatureButtonsBehavior() {
        let enable = (StateMachine.state == DefaultStates.Idle) && !GameModel.isReplay;
        const enableBuyFeature: boolean = !(VendorModel.settings?.disableBuyFeature === "true");
        const enableDoubleChance: boolean = !(VendorModel.settings?.scatterBoostDisable === "true");

        const buyFeatureVis = Configs.buyFeature?.maxFeaturePurchasePrice /* && !Configs.game.clientConfig.disableBuyFeature */ &&
        ((!SpinModel.inFreegames() && !SpinModel.isInFreespins())
        && !AutoplayModel.isAutoSpinActive());
        // const doubleChanceBtn = this.scene.buttons.get("buyfeatureSpin");
        const doubleChanceBtn = this.scene.buttons.get(Layout.isLandscape()?"buyfeatureSpin":"buyfeatureSpin_pt");
        doubleChanceBtn.setEnabled(!AutoplayModel.isAutoSpinActive() && enable && enableDoubleChance);
        this.scene.groups.get("btn_double_chance").visible = !SpinModel.inFreegames()
            && !SpinModel.isInFreespins()
            && !AutoplayModel.isAutoSpinActive();

        this.scene.groups.get("btn_buy_feature").visible = buyFeatureVis;
        this.scene.buttons.get(UIButtons.FeatureBuy).visible = buyFeatureVis;
        doubleChanceBtn.visible = !SpinModel.isInFreespins();
        this.scene.buttons.get(UIButtons.FeatureBuy).setEnabled(!DoubleChanceModel.isActivated && enable && enableBuyFeature);

        if (GameModel.gameConfig.GAME_RULES_ALWAYS_AVAILABLE_JURISDICTIONS
            .find((jurisdiction) => jurisdiction == GameModel.jurisdiction)) {
            this.scene.buttons.get(UIButtons.Settings).setEnabled(true);
        }

        // group items are not part of the button and must be managed separately
        this.scene.groups.get("btn_double_chance").alpha = enable && enableDoubleChance ? 1 : 0.5;
        if (!DoubleChanceModel.isActivated) {
            this.scene.groups.get("btn_buy_feature").alpha = enable && enableBuyFeature ? 1 : 0.5;
        }
        // this.scene.groups.get("btn_buy_feature").getChildAt(2).alpha = enable ? 1 : 0.5; // buy feature text

        if (!enableDoubleChance) this.scene.groups.get("btn_double_chance").alpha = 0;
        if (!enableBuyFeature) this.scene.groups.get("btn_buy_feature").alpha = 0;
    }


}
